import VehiclesAnalytics from '@/components/vehicles/VehiclesAnalytics';

export default function VehiclesAnalyticsPage() {
  return (
    <div className="space-y-6 animate-fade-in px-4 sm:px-6 lg:px-8 pt-6">
      <div className="mb-8">
        <h1 className="text-4xl font-semibold tracking-tight mb-2">Vehicle Analytics</h1>
        <p className="text-muted-foreground">Fleet performance, composition, and compliance metrics.</p>
      </div>

      <VehiclesAnalytics />
    </div>
  );
}
